import {
  GenericHttpError,
  type GenericHttpResponse,
} from '@iconik-io/core/src/http/generic_http_transport';
import type { Result } from '@iconik-io/core/src/result';

import type { GenericRetryOptions } from '../client/request';

type DebugLogger = {
  debug: (...args: unknown[]) => void;
};

export function calculateRetryDelay(args: {
  result: Result<GenericHttpResponse>;
  retryOptions?: GenericRetryOptions;
  defaultDelay: number;
  logger: DebugLogger;
}): number {
  const { retryOptions, defaultDelay, result, logger } = args;
  const { minTimeout = 0, maxTimeout = 60_000 } = retryOptions ?? {};
  let delay = Math.min(Math.max(defaultDelay, minTimeout), maxTimeout);

  if (!result.ok) {
    const error = result.error;
    if (error instanceof GenericHttpError && error.response) {
      const retryAfter = error.response.headers['retry-after'];
      if (retryAfter !== undefined) {
        logger.debug('Retrying based on retry-after', retryAfter);
        delay = Number(retryAfter) * 1000;
      }
    }
  }

  logger.debug('Retrying in', delay, 'ms');
  return delay;
}
